import { render, staticRenderFns } from "./BuildDetails.vue?vue&type=template&id=56e068a7"
import script from "./BuildDetails.vue?vue&type=script&lang=js"
export * from "./BuildDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports